import { XMarkIcon } from "@heroicons/react/24/outline";

type ChangeResponsibleSuccessModalProps = {
  onClose: () => void;
};

function ChangeResponsibleSuccessModal({ onClose }: ChangeResponsibleSuccessModalProps) {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/20">
      <div className="relative flex w-[644px] flex-col rounded-lg bg-white shadow-xl">
        <button
          type="button"
          className="absolute left-[calc(100%+16px)] top-0 flex items-center justify-center"
          onClick={onClose}
          aria-label="Закрыть"
        >
          <XMarkIcon className="h-[36px] w-[36px] text-white" strokeWidth={1.5} />
        </button>

        <div className="px-11 pt-11 pb-10">
          <h2 className="mb-10 text-[28px] leading-[34px] font-bold text-[#111928]">
            Готово
          </h2>
          <p className="text-[16px] leading-[22px] text-[#111928]">
            Ответственный за пересмотр успешно изменен.
          </p>
        </div>

        <div className="flex justify-center border-t border-[#DFE4EA] px-10 py-[42px]">
          <button
            type="button"
            className="h-[52px] min-w-[126px] rounded-md bg-[#012169] px-6 text-[16px] leading-[22px] font-medium text-white"
            onClick={onClose}
          >
            Закрыть
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChangeResponsibleSuccessModal;
